"use client";

import { useState } from "react";
import Link from "next/link";
import LocaleSwitcher from "./LocaleSwitcher";

export default function MobileMenu({ locale, dict, locales }) {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const closeMenu = () => {
        setIsOpen(false);
    };

    return (
        <>
            {/* Mobile menu button */}
            <button
                onClick={toggleMenu}
                className="md:hidden p-2 rounded-md hover:bg-zinc-100 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                aria-label="Toggle mobile menu"
                aria-expanded={isOpen}
            >
                <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    {isOpen ? (
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M6 18L18 6M6 6l12 12"
                        />
                    ) : (
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M4 6h16M4 12h16M4 18h16"
                        />
                    )}
                </svg>
            </button>

            {/* Mobile menu overlay */}
            {isOpen && (
                <div className="fixed inset-0 z-50 md:hidden">
                    <div className="fixed inset-0 bg-black bg-opacity-50" onClick={closeMenu}></div>
                    <div className="fixed top-0 right-0 h-full w-80 max-w-sm bg-white shadow-xl">
                        <div className="flex items-center justify-between p-4 border-b border-zinc-200">
                            <Link href={`/${locale}`} className="flex items-center gap-2" onClick={closeMenu}>
                                <img src="/assets/logo/logo.svg" alt="SmartClip" className="h-8 w-auto" />
                            </Link>
                            <button
                                onClick={closeMenu}
                                className="p-2 rounded-md hover:bg-zinc-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                aria-label="Close mobile menu"
                            >
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>

                        <nav className="p-4 space-y-4">
                            <Link
                                href={`/${locale}/products`}
                                className="block py-3 px-4 text-lg font-medium text-zinc-700 hover:text-blue-700 hover:bg-blue-50 rounded-md transition-colors"
                                onClick={closeMenu}
                            >
                                {dict.nav.products}
                            </Link>
                            <Link
                                href={`/${locale}/compatibility`}
                                className="block py-3 px-4 text-lg font-medium text-zinc-700 hover:text-blue-700 hover:bg-blue-50 rounded-md transition-colors"
                                onClick={closeMenu}
                            >
                                {dict.nav.compatibility}
                            </Link>
                            <Link
                                href={`/${locale}/history`}
                                className="block py-3 px-4 text-lg font-medium text-zinc-700 hover:text-blue-700 hover:bg-blue-50 rounded-md transition-colors"
                                onClick={closeMenu}
                            >
                                {dict.nav.history}
                            </Link>
                            <Link
                                href={`/${locale}/about`}
                                className="block py-3 px-4 text-lg font-medium text-zinc-700 hover:text-blue-700 hover:bg-blue-50 rounded-md transition-colors"
                                onClick={closeMenu}
                            >
                                {dict.nav.about}
                            </Link>
                            <Link
                                href={`/${locale}/contact`}
                                className="block py-3 px-4 text-lg font-medium text-zinc-700 hover:text-blue-700 hover:bg-blue-50 rounded-md transition-colors"
                                onClick={closeMenu}
                            >
                                {dict.nav.contact}
                            </Link>

                            <div className="pt-4 border-t border-zinc-200">
                                <p className="text-sm font-medium text-zinc-500 mb-3">Language</p>
                                <LocaleSwitcher currentLocale={locale} locales={locales} />
                            </div>
                        </nav>
                    </div>
                </div>
            )}
        </>
    );
}
